import React, { useState } from 'react';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import dropShippingImg from '../../../../assets/images/dropshipping.jpg';
import { notify, validator } from '@monorepo/utils';
import { isValidationError } from '@monorepo/rest-client';
import { useHistory, useLocation } from 'react-router-dom';
import { useLazyGetTrackingDetail } from '../../../../data/orderTracking/hooks';
import queryString from 'query-string';
import FormField from '../../../../components/LookupForm/FormField';
import LookupFormLayout from '../../../../components/LookupForm/LookupFormLayout';
import LookupCaptcha from '../../../../components/LookupForm/LookupCaptcha';
import LookupSubmitButton from '../../../../components/LookupForm/LookupSubmitButton';

const OrderTrackingForm = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const { getOrderDetail } = useLazyGetTrackingDetail();

  const [orderCode, serOrderCode] = useState(location?.state?.orderCode || '');
  const [phoneNum, serPhoneNum] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const [form] = Form.useForm();

  // BE phân biệt sẵn "sai mã đơn" với "sai số điện thoại" và đã dịch sang tiếng Việt, nên hiện thẳng
  // câu của BE thay vì tự chế câu khác. Chỉ tự viết khi BE không nói gì cụ thể.
  // Nhận mọi mã 4xx chứ không riêng 400, để không vỡ nếu BE đổi sang 404 như FE đã đề nghị.
  const describeError = (error) => {
    if (error?.status === 429) return { message: t('common.rateLimited') };
    if (error?.status >= 400 && error?.status < 500 && !isValidationError(error) && error?.message) {
      return { message: error.message };
    }
    return { message: t('orderTracking.orderTrackingError') };
  };

  const handleTrackSubmit = async () => {
    const formValues = { orderCode: orderCode, phoneNumber: phoneNum };

    // Khác thời GraphQL gọi 1 phát: giờ lỗi mạng/5xx còn được thử lại 2 lần nên có thể chờ vài giây.
    // Không khoá nút thì người dùng tưởng bấm hụt.
    setSubmitting(true);
    try {
      await getOrderDetail({ variables: formValues });
      history.push({
        pathname: '/order-tracking/detail',
        search: queryString.stringify({ orderCode: formValues.orderCode }),
        state: formValues,
      });
    } catch (error) {
      notify.error(describeError(error));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Form
      form={form}
      onFinish={handleTrackSubmit}
      initialValues={{ 'order-code': orderCode, 'phone-number': phoneNum }}
    >
      <LookupFormLayout
        title={t('orderTracking.form.title')}
        note={t('orderTracking.form.note')}
        illustration={dropShippingImg}
        illustrationAlt="drop-shipping-logo"
      >
        <FormField
          label={t('orderTracking.form.orderCodeLabel')}
          required
          name="order-code"
          placeholder={t('orderTracking.form.orderCodePlaceholder')}
          value={orderCode}
          onChange={(e) => serOrderCode(e.target.value)}
          rules={[
            {
              required: true,
              message: t('orderTracking.form.validateBlankOrderCode'),
            },
          ]}
        />
        <FormField
          label={t('orderTracking.form.phoneNumLabel')}
          required
          name="phone-number"
          placeholder={t('orderTracking.form.phoneNumPlaceholder')}
          value={phoneNum}
          onChange={(e) => serPhoneNum(e.target.value)}
          rules={[
            {
              required: true,
              message: t('orderTracking.form.validateBlankPhoneNumber'),
            },
            validator({
              type: 'phone',
            }),
          ]}
        />
        <LookupCaptcha />

        <LookupSubmitButton loading={submitting} />
      </LookupFormLayout>
    </Form>
  );
};

export default OrderTrackingForm;
